import Link from "next/link";
import { PublicProfile } from "@dimensional-engineering/dimensional-models";

import styles from "./HighestScoringTraits.module.css";

import {
  ExtendedScale,
  HighestScoringTraitsModel,
} from "@/models/sharedModels";
import PeerIcon from "@/components/premium/reports/blindspot/PeerIcon";
import { isNotDiscoverable } from "@/assets/traitInfo/isNotDiscoverable";
import { getElementFromTraitIdentifier } from "@/components/authenticatedProfile/tabs/AuthCompareTab/utils";
import { natureData } from "@/assets/traitInfo/natureData";
import PeerAssessmentIcon from "@/components/shared/icons/PeerAssessmentIcon";
import PublicProfilesGhostBox from "../PublicProfilesGhostBox/PublicProfilesGhostBox";

export function HighestScoringTraitsPublicProfiles(props: {
  data: HighestScoringTraitsModel | null;
  publicProfile?: PublicProfile | null;
}) {
  if (!props.data) {
    return (
      <div className={styles.ghosBoxDiv}>
        <PublicProfilesGhostBox />
      </div>
    );
  }

  const mappedSelfRated = props.data.selfRated.map((el) => {
    const element = getElementFromTraitIdentifier(el) as ExtendedScale;
    const color =
      natureData?.find((n) => n.slug === element.nature)?.color ?? "gray";

    if (!isNotDiscoverable.includes(el.slug)) {
      return (
        <Link
          href={`/traits/elements/${el.slug}`}
          className={styles.elDiv}
          key={el.slug}
          target="__blank"
        >
          <p style={{ borderColor: color }} className={styles.elementName}>
            {element.alias ?? element.name}
          </p>
        </Link>
      );
    }
  });

  const mappedPeerRated = props.data.peerRated.map((el) => {
    const element = getElementFromTraitIdentifier(el) as ExtendedScale;
    const color =
      natureData?.find((n) => n.slug === element.nature)?.color ?? "gray";

    if (!isNotDiscoverable.includes(el.slug)) {
      return (
        <Link
          href={`/traits/elements/${el.slug}`}
          className={styles.elDiv}
          key={el.slug}
          target="__blank"
        >
          <p style={{ borderColor: color }} className={styles.elementName}>
            {element.alias ?? element.name}
          </p>
        </Link>
      );
    }
  });

  return (
    <div className={styles.mainPublic}>
      <div className={styles.parentPublic}>
        <div className={styles.titleDiv}>
          <h3 className={styles.titlePublic}>Self-rated</h3>
          <PeerIcon light />
        </div>
        <p className={styles.subTitle}>How they see themselves.</p>
        {props.data.selfRated.length ? (
          <div className={styles.wrapperPublic}>{mappedSelfRated}</div>
        ) : (
          <div className={styles.ghosBoxDiv}>
            <PublicProfilesGhostBox />
          </div>
        )}
      </div>
      <div className={styles.parentPublic}>
        <div className={styles.titleDiv}>
          <h3 className={styles.titlePublic}>Peer-rated</h3>
          <PeerAssessmentIcon />
        </div>
        <p className={styles.subTitle}>How people they know perceive them.</p>
        {props.data.peerRated.length ? (
          <>
            <div className={styles.wrapperPublic}>{mappedPeerRated}</div>
          </>
        ) : (
          <div className={styles.ghosBoxDiv}>
            <PublicProfilesGhostBox />
          </div>
        )}
      </div>
    </div>
  );
}
